import { CardNumberElement } from '@stripe/react-stripe-js';
import type { StripeCardNumberElementChangeEvent } from '@stripe/stripe-js';
import { createCardField } from './utils';

export const CardNumber = createCardField<StripeCardNumberElementChangeEvent>({
  ElementComponent: CardNumberElement,
  elementKind: 'cardNumber',
  label: 'Card number',
  placeholder: '0000 0000 0000 0000',
  wrapperClassName: 'gap-sm',
});
